/**
 * Logger component to be used throughout the project for logging.
 * Based on debug npm module: https://github.com/visionmedia/debug
 *
 * Usage:
 *
 * const log = new Log("MyComponent");
 *
 * log.info("some log");
 * log.warn("some warn log");
 * log.error("some error log");
 */
import debug from "debug";
export class Logger {
    constructor(context) {
        const fullContext = "auvious" + (context && context.length > 0 ? "::" + context : "");
        this.debug = debug(fullContext);
        this.debug.log = console.debug.bind(console);
        this.info = debug(fullContext);
        this.info.log = console.info.bind(console);
        this.warn = debug(fullContext);
        this.warn.log = console.warn.bind(console);
        this.error = debug(fullContext);
        this.error.log = console.error.bind(console);
    }
}
